export default __webpack_public_path__ + "static/media/warning--atv-and-snowmobiles--g1.6e6cfa37.png";